<script>
    import {Link} from 'svelte-routing';
    import { Splide, SplideSlide } from '@splidejs/svelte-splide';
    import '@splidejs/svelte-splide/css';
    import TopMenu from '../components/TopMenu.svelte';
    import Footer from '../components/Footer.svelte';
    import {store} from '../stores.js';
    import {list} from '../config.js';
    import {load_order, load_user} from '../events.js';

	const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);
    const amo = store('amo', '', false);
    const cart = store('cart-items', '', '[]');
    const cart_data = store('cart-data', '', '{"id": 0, "nomDoc": -1, "nomDocStr": "", "fio": "", "tel": "", "email": "", "address": "", "comment": "", "note": ""}');

    let wrapper;

    // очищаем корзину
    if ($amo) {
        cart.remove();
        cart_data.remove();
    }

    // заполняем данные по юзеру
    load_user(cart, cart_data);

    // загрузка заказа из ТМ
    load_order(cart, cart_data);

    const options = {
        perPage: 1,
        fixedWidth : '100%',
        pagination: false,
        lazyLoad: 'sequential'
    };
</script>

 <TopMenu title="Выбор калькулятора" />

<div id="appCapsule" bind:this={wrapper}>
    <div class="section">
        <div class="row">
            {#each list as item}
                {#if
                    (
                        $user && $user.calcs && $user.calcs.includes(item.calc)
                    ) && (
                        typeof item.hide === 'undefined' ||
                        item.hide === false
                    )
                }
                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-2 d-flex align-items-stretch">
                        <div class="card">
                            {#if !$axis}
                                {#if item.img.length }
                                    {#if item.img.includes(',')}
                                        <Splide options={options}>
                                            {#each item.img.split(',') as img}
                                                <SplideSlide>
                                                    <img src="{ img }" class="card-img-top" alt="image" style="width: auto; object-position: center center; object-fit: cover;" />
                                                </SplideSlide>
                                            {/each}
                                        </Splide>
                                    {:else}
                                        <Link to="/calc/{ item.link }">
                                            {#if item.img.includes('mp4') }
                                                <video class="card-img-top" width="320" height="240" controls autoplay muted loop style="width: 100%; object-position: center center; object-fit: cover;" >
                                                    <source src="{ item.img }" type="video/mp4">
                                                    Ваш браузер не поддерживает тег video.
                                                </video>
                                            {:else}
                                                <img src="{ item.img }" class="card-img-top" alt="image" style="width: 100%; object-position: center center; object-fit: cover;" />
                                            {/if}
                                        </Link>
                                    {/if}
                                {/if}
                            {/if}
                            <div class="card-body pt-2">
                                <h4 class="mb-0">{ item.title }</h4>
                                <p class="mb-0">{ item.description }</p>
                            </div>
                            <div class="card-footer">
                                <Link to="/calc/{ item.link }" class="btn btn-primary btn-block">Открыть</Link>
                            </div>
                        </div>
                    </div>
                {/if}
            {/each}
        </div>
    </div>
</div>

<Footer />
